module.exports = __webpack_public_path__ + "static/media/plus-octagon.d3ba611b.svg";